import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=996319aa&"
import script from "./SubHeader.vue?vue&type=script&lang=js&"
export * from "./SubHeader.vue?vue&type=script&lang=js&"
import style0 from "@/styles/SubHeader.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports